export const APP_NAME = "Options Tool";
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
export const PRIVACY_POLICY_URL = "https://opticassetmanagement.com/privacy-policy/";
export const TERMS_OF_SERVICE_URL = "https://opticassetmanagement.com/terms-of-service/";
export const DISCLAIMER_URL = "https://opticassetmanagement.com/disclaimer/";
export const LOGO_URL = "/logo.svg";
export const LOGO_URL_SMALL = "/logo-small.svg";